export { FixedStageEntryPoint } from './scope';
